import React, { lazy } from "react";
import UIDs from "../../UIDs";
import NotFound from "../../layouts/errors/not-found/index.jsx";

const OldLoginScreen = lazy(() => import("../../screens/account/OldLoginScreen.jsx"));
const LoginScreen = lazy(() => import("../../screens/account/LoginScreen.jsx"));
const SSORedirectScreen = lazy(() => import("../../screens/account/SSORedirectScreen"));

export const accountRoutes = [
    {
        path: "/login",
        uid: UIDs.screens.account.login,
        layout: "/account",
        element: LoginScreen ,
    },
    {
        path: "/oldlogin",
        uid: UIDs.screens.account.oldlogin,
        layout: "/account",
        element: OldLoginScreen ,
    },
    {
        path: "/ssoredirect",
        uid: UIDs.screens.account.ssoredirect,
        layout: "/account",
        element: SSORedirectScreen ,
    },
    {
        path: "/error/notfound",
        uid: UIDs.screens.errors.notfound,
        layout: "",
        element: NotFound ,
    },
];
